/**
 * DeviceModelId is a unique identifier to identify the model of a Ledger hardware wallet.
 */
export var DeviceModelId;
(function (DeviceModelId) {
    DeviceModelId["blue"] = "blue";
    DeviceModelId["nanoS"] = "nanoS";
    DeviceModelId["nanoSP"] = "nanoSP";
    DeviceModelId["nanoX"] = "nanoX";
    DeviceModelId["stax"] = "stax";
})(DeviceModelId || (DeviceModelId = {}));
/**
 *
 */
export var ChargingModes;
(function (ChargingModes) {
    ChargingModes[ChargingModes["NONE"] = 0] = "NONE";
    ChargingModes[ChargingModes["USB"] = 1] = "USB";
    ChargingModes[ChargingModes["QI"] = 2] = "QI";
})(ChargingModes || (ChargingModes = {}));
//# sourceMappingURL=index.js.map